import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { SCALES } from "../theme";
import { COLORS } from "../theme";
const MinusIcon = ({ color, onClick }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 50,
        height: 15,
        width: 15,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      <RemoveCircleIcon
        style={{
          color: color ? color : COLORS.primary_navyblue,
          // fontSize: "2.2vmin",
          borderRadius: 100,
        }}
      ></RemoveCircleIcon>
    </div>
  );
};

export default MinusIcon;
